module.exports = __webpack_public_path__ + "static/media/esif_logo.b1d67668.svg";